import apiClient from '../helpers/apiClient'

export interface PayoutListParams {
  limit?: number
  offset?: number
  actionType?: string        // comma-separated
  status?: string            // comma-separated
  member?: string            // comma-separated user ids
  partner?: string           // comma-separated user ids
  dateFrom?: string          // ISO datetime
  dateTo?: string            // ISO datetime
}

export const getPayouts = async (params: PayoutListParams = {}) => {
  // Backend uses snake_case query params; the camel-case middleware only affects
  // response bodies, so we map manually here.
  const query: Record<string, any> = {
    limit: params.limit,
    offset: params.offset,
    action_type: params.actionType,
    status: params.status,
    member: params.member,
    partner: params.partner,
    date_from: params.dateFrom,
    date_to: params.dateTo,
  }
  Object.keys(query).forEach((k) => (query[k] === undefined || query[k] === '') && delete query[k])
  const response = await apiClient.get('/payouts/', { params: query })
  return response.data
}

export const getPayoutDetail = async (id: number) => {
  const response = await apiClient.get(`/payouts/${id}/`)
  return response.data
}

export const getPlatformBankAccounts = async () => {
  const response = await apiClient.get('/payouts/platform-bank-accounts/')
  return response.data
}

export interface RegisterTransferPayload {
  transferDate: string          // YYYY-MM-DD
  amount: string                // decimal as string
  originatingBank: number       // id
  reference: string
  receiptKey?: string
  notes?: string
  markedAs: 'in_transit' | 'paid'
  idempotencyKey: string
  beneficiaryAccountHolder?: string
  beneficiaryBankName?: string
  beneficiaryAccountNumber?: string
  beneficiaryCountry?: string
}

export const registerTransfer = async (payoutId: number, payload: RegisterTransferPayload) => {
  const body = {
    transfer_date: payload.transferDate,
    amount: payload.amount,
    originating_bank: payload.originatingBank,
    reference: payload.reference,
    receipt_key: payload.receiptKey ?? '',
    notes: payload.notes ?? '',
    marked_as: payload.markedAs,
    idempotency_key: payload.idempotencyKey,
    beneficiary_account_holder: payload.beneficiaryAccountHolder ?? '',
    beneficiary_bank_name: payload.beneficiaryBankName ?? '',
    beneficiary_account_number: payload.beneficiaryAccountNumber ?? '',
    beneficiary_country: payload.beneficiaryCountry ?? '',
  }
  const response = await apiClient.post(`/payouts/${payoutId}/transfers/`, body)
  return response.data
}

export const togglePayoutHold = async (id: number, reason?: string) => {
  const response = await apiClient.post(`/payouts/${id}/hold/`, reason ? { reason } : {})
  return response.data
}

export const cancelPayout = async (id: number, reason: string) => {
  const response = await apiClient.post(`/payouts/${id}/cancel/`, { reason })
  return response.data
}
